// extracted by mini-css-extract-plugin
module.exports = {"github":"SidePanel_github__xV9Xw","block":"SidePanel_block__QBp2F","block__title":"SidePanel_block__title__zAzis"};